import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Presentations from '../Presentations/Presentations';
import PresentationsStart from '../PresentationsStart/PresentationsStart';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.presentations)
        }}
      >{formatMessage('navTitlePresentations')}</MenuItem>
   </React.Fragment>
  }
}

const PresentationsStartPage = (props) => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <PresentationsStart {...props}  />
  </Wrapper>
}

export default PresentationsStartPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/PresentationsStartPage.js